<span *ngIf="headerName" class="gat-card-header-name">{{headerName}}</span>
<ng-content></ng-content>